// ----- INSTANCE CONFIGURATION — YOU CAN MODIFY THIS FILE -----
// This file isolates all instance-specific configuration from the generated stack9 core files.
// Add your custom components, routes, and UIProvider extensions here.
//
// Generated files (_app.tsx, _app.core.module.tsx, _app.standard.modules.tsx, index.tsx)
// are upgraded by stack9-cli and must not be edited directly.
// ----- INSTANCE CONFIGURATION — YOU CAN MODIFY THIS FILE -----

import * as pagesModule from '@april9au/stack9-pages-ui';

import { Stack9FrontendAppProvider, Stack9InstanceConfig } from './_app';

import { ActionBarComponent } from './components/ActionBarComponent';
import { SubmissionReport } from './pages/SubmissionReport';

// Add any instance-specific global styles here:
import './app.stack9.instance.global.css';

/**
 * Instance-specific configuration passed into the core provider.
 * Extend this to add custom components, routes, or UIProvider extensions.
 */
export const instanceConfig: Stack9InstanceConfig = {
  extensions: {
    ActionBarComponent,
  },
  instanceComponents: [...pagesModule.components],
  instanceRoutes: [
    ...pagesModule.customRoutes,
    { route: '/submission-report', component: <SubmissionReport /> },
  ],
};

/**
 * Top-level provider for this stack9 instance.
 * Wraps the generated Stack9FrontendAppProvider with instance config applied.
 * Imported by index.tsx to bootstrap the app.
 */
export function Stack9InstanceFrontend() {
  return <Stack9FrontendAppProvider instanceConfig={instanceConfig} />;
}
